import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/agencias/';

/**
 * GET Agencias
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getAgencias = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Agencia
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getAgencia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Agencia
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postAgencia = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Agencia
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchAgencia = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Agencia
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteAgencia = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Agencia
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosAgencia = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Agencias para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getAgenciasCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/agencia-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
